import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { getCurrentUser } from '@onviobr/services/profile/user';
import { Locale } from '@onviobr/toolbox-file-viewer';
var userLangToPdfTronLang = {
  'en-US': Locale.en,
  'en-CA': Locale.en_ca,
  'en-GB': Locale.en_gb,
  'fr-CA': Locale.fr,
  'pt-BR': Locale.pt_br,
  'es-AR': Locale.es,
  'en-IN': Locale.en,
  'en-AU': Locale.en_au,
  'es-PE': Locale.es,
  'es-CL': Locale.es,
  'xx-XX': Locale.en
};
var pdfTronLangPromise;
export function mockUserLanguage(lang) {
  pdfTronLangPromise = Promise.resolve(lang);
}
export function resetUserLanguage() {
  pdfTronLangPromise = undefined;
}
export function getLanguage() {
  return _getLanguage.apply(this, arguments);
}
function _getLanguage() {
  _getLanguage = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var defaultLocale;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!pdfTronLangPromise) {
            defaultLocale = Locale.en;
            pdfTronLangPromise = getCurrentUser().then(function (user) {
              var _userLangToPdfTronLan;
              return (_userLangToPdfTronLan = userLangToPdfTronLang[user.language]) !== null && _userLangToPdfTronLan !== void 0 ? _userLangToPdfTronLan : defaultLocale;
            });
          }
          return _context.abrupt("return", pdfTronLangPromise);
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _getLanguage.apply(this, arguments);
}
